import { makeStyles } from "@material-ui/styles";
import CommonNavbar from "common/components/CommonNavbar";
import { StoreState } from "common/store/types";
import { LOGOUT_ACTION } from "common/store/user/actions";
import { UserManageable } from "common/store/user/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Logout from "../common/assets/images/logout.svg";
import LogoutHover from "../common/assets/images/logouthover.svg";

const LogoutIcon = (isHovered: boolean) =>
  <img src={isHovered ? LogoutHover : Logout} alt="logout" />
;

const navbarStyle = makeStyles({
  root: {
    zIndex: 2000,
    backgroundColor: "white !important",
    boxShadow: "0px 21.7852px 43.5704px rgba(0, 0, 0, 0.05) !important",
  },
});

export default function Navbar() {
  // Hooks
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const storageUserDetails = useSelector<StoreState, UserManageable>((state) => state.currentUser);

  // Options
  let options = (vertical: boolean) => [
    {
      text: t("Investments"),
      visible: () => true,
      onClick: () => history.push("/landing"),
      icon: null,
      className: () =>
        location.pathname === "/landing" ? "active-item" : "",
    },
    {
      text: t("Users"),
      visible: () => true,
      onClick: () => history.push("/users"),
      icon: null,
      className: () =>
        location.pathname === "/users" ? "active-item" : "",
    },
    {
      text: t("Sales"),
      visible: () => true,
      onClick: () => history.push("/assets"),
      icon: null,
      className: () =>
        location.pathname === "/assets" ? "active-item" : "",
    },
    {
      text: t("Logout"),
      visible: () => vertical,
      onClick: () => {
        dispatch({ type: LOGOUT_ACTION });
        history.push("/");
      },
      icon: LogoutIcon,
      className: () => "",
    },
  ];

  const pageName = () => {
    switch (location.pathname) {
      case "/landing":
        return t("Investments");
      case "/users":
        return t("Users");
      case "/assets":
        return t("Sales");
      default:
        return "";
    }
  };

  const name = storageUserDetails.firstName
    ? storageUserDetails.firstName
    : "?";

  const classes = navbarStyle();

  return (
    <CommonNavbar
      classes={classes}
      name={name}
      pageName={pageName()}
      homeURL={"/landing"}
      options={options}
    />
  );
}